var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DemoIframe',_vm._b({key:_vm.$route.path,attrs:{"resource":"users","providerParams":{ term: _vm.$route.params.user },"demoUrl":_vm.demoUrl},on:{"load-item":_vm.loadUser}},'DemoIframe',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }